export enum RemindersDomainTypes {
  Registry = 1,
  Underwriting = 2,
  Claim = 3,
  Pension = 4,
  NewUnderwriting = 5,
}
